/**
 * Configuration lue au build.
 *
 * Seules les variables préfixées `VITE_` entrent dans le bundle : elles sont donc
 * publiques, aucun secret ne passe par là. `VITE_API_URL` est la racine de l'API
 * **sans** `/api/v1` : le client ajoute le préfixe, et le canal temps réel se
 * branche sur `<url>/realtime`.
 */
const apiUrl = (import.meta.env.VITE_API_URL as string | undefined)?.trim();

export const ENV = {
  API_URL: (apiUrl && apiUrl.length > 0 ? apiUrl : 'http://localhost:4000').replace(/\/$/, ''),
} as const;
